// extracted by mini-css-extract-plugin
export default {"pageRoot":"StripeCheckout_pageRoot__nU1N4"};